/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
import _ from 'lodash';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import uuid from 'react-uuid';

import {
  setFormTemplateVersion,
  addANewField,
  setFormTemplateValue,
  setActiveAccordion,
} from '../../redux/actions/formTemplateActions';
import { saveFormTemplate, setFormTemplatesError } from '../../redux/actions/formTemplateApiActions';
import FormTemplateFormContainer from './FormTemplateFormContainer';

export function NewFormTemplateContainer(props) {
  const {
    setFormTemplateVersion,
    addANewField,
    formTemplateVersion,
    setFormTemplateValue,
    saveFormTemplate,
    setActiveAccordion,
    defaultFormTemplateVersion,
    defaultFormTemplateField,
    formTemplateRequest,
    setFormTemplatesError,
  } = props;

  const { loading, requestType } = formTemplateRequest;
  useEffect(() => {
    const id = uuid();
    const initialVersion = {
      ...defaultFormTemplateVersion,
      fields: [{ ..._.cloneDeep(defaultFormTemplateField), id }],
    };
    setFormTemplateVersion(initialVersion);
    setActiveAccordion(id);
  }, [defaultFormTemplateVersion]);

  const addAField = () => {
    const id = uuid();
    addANewField({ ..._.cloneDeep(defaultFormTemplateField), id });
    setActiveAccordion(id);
  };

  const handleTemplateChange = (value, templateAttributeId) => {
    setFormTemplateValue(templateAttributeId, value);
  };

  useEffect(() => {
    return () => {
      if (requestType) setFormTemplatesError({}, null);
    };
  }, [requestType]);

  return (
    <div className="template-builder_content-wrapper">
      {!loading && (
        <FormTemplateFormContainer
          formTemplate={formTemplateVersion}
          handleTemplateChange={handleTemplateChange}
          addAField={addAField}
          handleFormAction={saveFormTemplate}
          formId={0}
          setActiveAccordion={setActiveAccordion}
          setFormTemplatesError={setFormTemplatesError}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    formTemplateVersion: state.formTemplateReducer.formTemplateVersion,
    defaultFormTemplateVersion: state.formTemplateApiReducer.defaultFormTemplate?.versions[0],
    defaultFormTemplateField: state.formTemplateApiReducer.defaultFormTemplate?.versions[0].fields[0],
    formTemplateRequest: state.formTemplateApiReducer.formTemplateRequest,
  };
};

const mapDispatchToProps = {
  addANewField,
  setFormTemplateVersion,
  setFormTemplateValue,
  saveFormTemplate,
  setActiveAccordion,
  setFormTemplatesError,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewFormTemplateContainer);
